// axiosConfig.ts
import axios, {
  AxiosError,
  AxiosInstance,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";
import { AppDispatch } from "../../store";
import { logout } from "../../features/user/UserSlice";
import { getAuthUser } from "../manageAuth";
import { toast } from "sonner";

let dispatch: AppDispatch | undefined;
let offlineToastShown = false;

export const setAxiosDispatch = (fn: AppDispatch): void => {
  dispatch = fn;
};

const customFetch: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

customFetch.interceptors.request.use(
  (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    const token = getAuthUser()?.accessToken;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
customFetch.interceptors.response.use(
  (response: AxiosResponse): AxiosResponse => {
    offlineToastShown = false;
    return response;
  },
  (error: AxiosError): Promise<never> => {
    // Network error / internet disconnected
    if (!error.response) {
      if (!offlineToastShown) {
        offlineToastShown = true;
        toast.error("No internet connection");
      }

      return Promise.reject(error);
    }

    // Reset flag once a valid response comes back
    offlineToastShown = false;

    // Session expiry
    if (error.response.status === 401 && dispatch) {
      const isAuthEndpoint = error.config?.url?.includes("/api/auth/");
      if (!isAuthEndpoint) {
        dispatch(logout("Session expired, please login again"));
      }
    }

    return Promise.reject(error);
  }
);

export default customFetch;
